import { IngInputBase } from './ing-input-base';

export class IngTextArea extends IngInputBase<string> {
  public rows: number;
  public cols: number;

  constructor(
    options: {
      value?: string,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      order?: number,
      rows?: number,
      cols?: number,
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}
  ) {
    super(options);

    this.rows = options.rows || 5;
    this.cols = options.cols || undefined;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-text-area.ts